import {CodeDesignation} from 'sigale-angular';
import {Duree} from '../../../models/duree.model';
import {TypeEvenementCalendrier} from './type-evenement-calendrier.model';

/**
 * Un évènement au sens calendrier.
 * Un évènement peut être un jour de télétravail, une absence ou une réservation.
 */
export abstract class EvenementCalendrier {
	// Comme l'objet peut contenir à la fois des évènements au sens BDD et des réservations,
	// on va construire un identifiant unique de l'évènement avec la date, la durée et l'ID
	uuid: string;
	id: number;
	date: Date;
	duree: CodeDesignation;

	protected constructor(id: number, date: Date, duree: CodeDesignation) {
		this.id = id;
		this.date = date;
		this.duree = duree;
		this.uuid = this.construireUuid();
	}

	/**
	 * Construit l'uuid pour avoir des évènements unique.
	 * @private
	 */
	private construireUuid() {
		const annee = this.date.getFullYear();
		const mois = String(this.date.getMonth() + 1).padStart(2, '0');
		const jour = String(this.date.getDate()).padStart(2, '0');
		return `${annee}-${mois}-${jour}.${this.duree.code}.${this.id}`;
	}

	estEvenementSurLaJournee() {
		return this.duree.code === Duree.JOURNEE;
	}

	abstract getType(): TypeEvenementCalendrier;
}
